import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'mandates-collapsable',
  templateUrl: './collapsable.component.html',
  styleUrls: ['./collapsable.component.scss']
})
export class CollapsableComponent {
  @Input() title: string = '';
  @Input() expanded: boolean = false;
  @Input() displayMode: 'header' | 'button' = 'header';

  @Output() expandedChange = new EventEmitter<boolean>();

  handleToggle() {
    this.expanded = !this.expanded;
    this.expandedChange.emit(this.expanded);
  }
}
